import React from 'react';

import { CarouselProvider, Slider, Slide, DotGroup } from 'pure-react-carousel';

import { PromoIcon } from '../../common/PromoIcon/PromoIcon';
import { WAIT_BEFORE_SLIDES_IS_ACTIVE } from '../../common/sections/Constants';
import { CarouselDotGroup } from '../../common/sections/styles';
import {
    CrossProductBanner,
    CrossProductDescription,
    CrossProductTitle,
    FlickitySlide,
    Illustration,
    Inner,
    LearnMore,
    Link,
    Logos,
    TextContent,
} from '../styles';

const CrossProductsAnimateLanding = (props) => {
    const { pathFirstSlider, pathSecondSlider, imgFirstSlider, imgSecondSlider, logosSecondSlider, learnMore } = props;
    return (
        <div className="section-cross-products">
            <div className="box-1280 flickity-viewport">
                <div className="inner-content">
                    <CarouselProvider
                        interval={WAIT_BEFORE_SLIDES_IS_ACTIVE}
                        naturalSlideHeight="100%"
                        naturalSlideWidth="100%"
                        totalSlides={2}
                        isPlaying={!__isDev__}
                        isIntrinsicHeight
                    >
                        <Slider>
                            <Slide index={0}>
                                <FlickitySlide>
                                    <CrossProductBanner href={pathFirstSlider}>
                                        <Inner>
                                            <TextContent>
                                                <CrossProductTitle>{props.sliderCrossProdTitle1}</CrossProductTitle>
                                                <CrossProductDescription>{props.sliderCrossProdText1}</CrossProductDescription>
                                                <Link>
                                                    <LearnMore>{learnMore}</LearnMore>
                                                    <PromoIcon name="chevron-right" size="24px" color="primary" />
                                                </Link>
                                            </TextContent>
                                            <Illustration>{imgFirstSlider}</Illustration>
                                        </Inner>
                                    </CrossProductBanner>
                                </FlickitySlide>
                            </Slide>
                            <Slide index={1}>
                                <FlickitySlide>
                                    <CrossProductBanner href={pathSecondSlider}>
                                        <Inner>
                                            <Logos>
                                                <figure>{logosSecondSlider}</figure>
                                            </Logos>
                                            <TextContent>
                                                <CrossProductTitle>{props.sliderCrossProdTitle2}</CrossProductTitle>
                                                <CrossProductDescription>{props.sliderCrossProdText2}</CrossProductDescription>
                                                <Link>
                                                    <LearnMore>{learnMore}</LearnMore>
                                                    <PromoIcon name="chevron-right" size="24px" color="primary" />
                                                </Link>
                                            </TextContent>
                                            <Illustration>{imgSecondSlider}</Illustration>
                                        </Inner>
                                    </CrossProductBanner>
                                </FlickitySlide>
                            </Slide>
                        </Slider>
                        <CarouselDotGroup>
                            <DotGroup />
                        </CarouselDotGroup>
                    </CarouselProvider>
                </div>
            </div>
        </div>
    );
};

export default CrossProductsAnimateLanding;
